import { createSlice } from '@reduxjs/toolkit'
import { api } from '../api';

export const userPermissionsSlice = createSlice({
  name: 'userPermissions',
  initialState: {
    permissions: []
  },
  reducers: {
    setUserPermissions: (state, { payload }) => {
        state.permissions = payload;
    },
  },
//   extraReducers : (builder) => {
//     builder.addMatcher(api.endpoints.getUserPermission.matchFulfilled, (state, {payload}) => {
//         state.permissions = payload;
//     })
//   }
})

// Action creators are generated for each case reducer function
export const { setUserPermissions } = userPermissionsSlice.actions
export default userPermissionsSlice.reducer